export default __webpack_public_path__ + "static/media/AU.557c9632.png";